import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../state/consts.ts";

export default function ModalInfoKostensteigerung() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1>Kostensteigerung</h1>
            <p>Die Energiepreissteigerung ist in der Ausgangsberechnung in Anlehnung an die Inflationsrate mit 3,0 % angegeben. Möchten Sie simulieren wie sich die Maßnahmen bei einer höheren Preissteigerung rechnen, können Sie den Prozentsatz nach oben anpassen. Bei Annahme einer geringen Preissteigerung kann der Prozentsatz nach unten angepasst werden.</p>
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

